import React, { useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
  handleDownloadPO,
  handlePurchaseOrderCreateUpdate,
} from "../../../commonHandlerFunction/Purchase/PurchaseOrder/PurchaseOrderHandler";
import CustomPopupModal from "../../../commonModalForms/CustomPopupModal";
import {
  decryptDataForURL,
  encryptDataForURL,
} from "../../../../../utills/useCryptoUtils";

const PurchaseButtons = ({
  formData,
  handleSubmit,
  setIsOverlayLoader,
  status,
  setFormData,
  viewOnly,
  editableIndex,
  setEditableIndex,
  setPopupAddPurchaseReq,
  setTableData,
  section,
  setIsRejectPopupOpen,
  moduleType,
  setIsCancelPopupOpen
}) => {
  let navigate = useNavigate();
  const [isCustomPopup, setIsCustomPopup] = useState(false);
  const [isPreClosed, setIsPreClosed] = useState(false);
  const hash = window.location.hash;
  const params = new URLSearchParams(hash.split("?")[1]);
  const actionType = decryptDataForURL(params.get("action"));
  const isVendorField = decryptDataForURL(params.get("isVendorField"));
  const isProdRecv = decryptDataForURL(params.get("isProdRecv"));
  const useFor = decryptDataForURL(params.get("useFor"));

  const handleCustomConfirmHandler = () => {
    const status = isPreClosed ? 5 : 2;
    handlePurchaseOrderCreateUpdate(
      formData,
      handleSubmit,
      setIsOverlayLoader,
      navigate,
      status,
      setFormData,
      "",
      setTableData,
      1,
    );
  };
  return (
    <div className="auditBtns">
      <Button
        type="button"
        className="cancelBtn"
        onClick={() =>
          moduleType === "purchaseInsurance"
            ? navigate(
              `/purchase/purchaseForm/${encryptDataForURL(formData[0]?.["po_id"])}?status=${encryptDataForURL("View")}` +
              "&isInsurance=" +
              encryptDataForURL(true),
            )
            : navigate(useFor === "po-dashboard" ? '/po-dashboard' : -1)
        }
      >
        Back
      </Button>
      {isProdRecv && (
        <>
          <Button
            type="button"
            className="submitBtn"
            onClick={() =>
              handlePurchaseOrderCreateUpdate(
                formData,
                handleSubmit,
                setIsOverlayLoader,
                navigate,
                5,
                setFormData,
                "",
                setTableData,
                1,
              )
            }
          >
            Pre Closed
          </Button>
          <Button
            type="button"
            className="submitBtn"
            onClick={() => {
              // handlePurchaseOrderCreateUpdate(formData, handleSubmit, setIsOverlayLoader, navigate, 7, setFormData, "", setTableData, 1)
              setIsRejectPopupOpen(true);
              setIsCancelPopupOpen(true);
            }}
          >
            Cancel PO
          </Button>
        </>
      )}
      {isVendorField && (
        <Button
          type="button"
          className="submitBtn"
          onClick={() =>
            handlePurchaseOrderCreateUpdate(
              formData,
              handleSubmit,
              setIsOverlayLoader,
              navigate,
              6,
              setFormData,
              "",
              setTableData,
              1,
            )
          }
        >
          Save
        </Button>
      )}

      {moduleType === "PoPreview" && !viewOnly && useFor != "po-dashboard" && (
        <>
          <Button
            type="button"
            className="submitBtn"
            onClick={() => {
              // const isValidate = handleSubmit();
              // if (!isValidate) {
              //     return false;
              // }
              setIsPreClosed(false);
              setIsCustomPopup(true);
            }}
          >
            Post
          </Button>
          {/* <Button
                            type="button"
                            className="submitBtn"
                            onClick={() => {
                                // const isValidate = handleSubmit();
                                // if (!isValidate) {
                                //     return false;
                                // }
                                setIsPreClosed(true)
                                setIsCustomPopup(true);
                            }}
                        >
                            Pre Close
                        </Button> */}
        </>
      )}

      {!viewOnly &&
        ["Saved", "Reject"].includes(formData[0].po_status) &&
        moduleType === "purchase" && (
          <>
            <Button
              type="button"
              className="submitBtn"
              disabled={formData[0]?.items?.length == 0}
              onClick={() =>
                handlePurchaseOrderCreateUpdate(
                  formData,
                  handleSubmit,
                  setIsOverlayLoader,
                  navigate,
                  1,
                  setFormData,
                  "",
                  setTableData,
                  1,
                )
              }
            >
              Save
            </Button>
            <Button
              type="button"
              className="submitBtn"
              disabled={formData[0]?.items?.length == 0}
              onClick={() => {
                handlePurchaseOrderCreateUpdate(
                  formData,
                  handleSubmit,
                  setIsOverlayLoader,
                  navigate,
                  1,
                  setFormData,
                  "",
                  setTableData,
                  1,
                  "",
                  1,
                );
              }}
            >
              Preview PDF
            </Button>
          </>
        )}
      {actionType == "approve" && (
        <>
          <Button
            type="button"
            className="submitBtn"
            onClick={(e) => setIsRejectPopupOpen(true)}
          >
            Reject
          </Button>
          <Button
            type="button"
            className="submitBtn"
            onClick={(e) =>
              handlePurchaseOrderCreateUpdate(
                formData,
                handleSubmit,
                setIsOverlayLoader,
                navigate,
                4,
                setFormData,
                "",
                setTableData,
                1,
              )
            }
          >
            Approve
          </Button>
        </>
      )}
      {isCustomPopup && (
        <CustomPopupModal
          isCustomPopup={isCustomPopup}
          setIsCustomPopup={setIsCustomPopup}
          handleConfirm={() => handleCustomConfirmHandler()}
          formData={formData}
          setFormData={setFormData}
          section={section.customField}
          moduleType={moduleType}
        />
      )}
    </div>
  );
};

export default PurchaseButtons;
